export function validateAndFormatNumber(value: string, field: string): string {
    try {
            // Check if the value is a number and has a length of 1 to 4 digits
    if (/^\d{1,4}$/.test(value.slice(0, 4))) {
        // Pad the number with leading zeros to ensure it is 4 digits long
        
        return `${field} ${value.padStart(4, '0')}`;
    } else {
        return value;
        // throw new Error('Invalid input: The value must be a numeric string with up to 4 digits.');
    }
    } catch (error) {
        return value;
    }

}
